import { EPropertyApplicability } from '../data/Constants';
import { IProperty, ISelectedTreeItem } from '../../types';
import { IPropAssociation } from '../../types/IRequestTypes';

//Formats the data to be sent in Property Association Request
export function getPropAssocRequest(material: ISelectedTreeItem): IPropAssociation {
  if (material.featureCode && material.productCode) {
    //Read and Save Associations Request for Options
    return {
      productCode: material.productCode,
      featureCode: material.featureCode,
      optionCode: material.code,
    };
  } else if (material.productCode) {
    //Read and Save Associations Request for Features
    return {
      productCode: material.productCode,
      featureCode: material.code,
    };
  } else {
    //Read and Save Associations Request for Product
    return {
      productCode: material.code,
    };
  }
}

// Removes keys with empty string or null values from an object
export function removeEmptyValues(obj: { [key: string]: string | null }) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== '' && v != null));
}

/**
 * Checks if a property is Master
 * @param {IProperty} property The property to check
 * @returns {boolean} True if the property's applicability includes Master, false otherwise
 */
export function checkIfMasterProperty(property: IProperty): boolean {
  return property.applicability.includes(EPropertyApplicability.Master);
}
